export default __webpack_public_path__ + "images/f7d7d5d2717195e3441e23121cce593e-holiday_collections_touchpoint_image.webp";